var React = require('react');

function Smartphone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z","key":0}),React.createElement("path",{"d":"M12 18H12.01","key":1})]);
}

Smartphone.defaultProps = {"viewBox":"0 0 24 24","className":"feather feather-smartphone"};

module.exports = Smartphone;

Smartphone.default = Smartphone;
